/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SectionHeader } from '../Shared/SectionHeader'
import { Section } from '../Shared/Section'
import { MonthlyPositiveActivityCard } from './Cards/MonthlyPositiveActivityCard'
import { TodayPositiveActivityCard } from './Cards/TodayPositiveActivityCard/TodayPositiveActivityCard'
import { UnavailableItemsSummaryCard } from './Cards/UnavailableItemsSummaryCard/UnavailableItemsSummaryCard'
import { NegativeActivityCard } from './Cards/NegativeActivityCard/NegativeActivityCard'

const BusinessPerformanceSection = () => {
    return (
      <>
          <SectionHeader title="Performance commerciale"/>

          <Section>
              <TodayPositiveActivityCard/>
              <MonthlyPositiveActivityCard/>
              <div css={css`
                  display: flex;
                  flex-direction: column;
                  row-gap: 1rem;
              `}>
                  <NegativeActivityCard/>
                  <UnavailableItemsSummaryCard/>
              </div>
          </Section>
      </>
    )
}

export { BusinessPerformanceSection }
